import { createFileRoute } from "@tanstack/react-router";
import Bokslut from "@/pages/Bokslut";
import { buildBreadcrumbSchema, getBreadcrumbTrail, buildPageSchema, buildSeoHead, buildServiceSchema, publicPageSeo } from "@/data/seo";

export const Route = createFileRoute("/bokslut")({
  head: () =>
    buildSeoHead(
      publicPageSeo.bokslut,
      [
        buildPageSchema(publicPageSeo.bokslut, "WebPage"),
        buildServiceSchema(publicPageSeo.bokslut, "Bokslut och deklaration", [
          "Årsredovisning",
          "Deklaration för aktiebolag",
          "K10 och 3:12",
          "Skatteplanering",
        ]),
        buildBreadcrumbSchema(getBreadcrumbTrail("/bokslut") ?? []),
      ],
    ),
  component: Bokslut,
});
